import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../shared/services/payment.service';

@Component({
  selector: 'cc-payment-spinner',
  templateUrl: './payment-spinner.component.html',
  styleUrls: ['./payment-spinner.component.scss']
})
export class PaymentSpinnerComponent implements OnInit {
  public spinnerVisible: boolean;
  constructor(public paymentService: PaymentService) {}

  ngOnInit() {
    this.paymentService.spinnerActivate.subscribe(activator => {
      this.spinnerVisible = activator;
    });
  }
}
